export enum Alignment {
    flexStart = 'flex-start',
    flexEnd = 'flex-end',
    center = 'center',
    stretch = 'stretch',
    baseline = 'baseline',
}
